<template v-if="imageOption || videoOption">
  <v-expand-transition>
    <div class="mb-8">
      <h4 class="title-type-3">소재</h4>
      <template>
        <div
          class="relative white rounded pa-6 pr-16"
          v-for="(resource, i) in resources"
          :key="i"
          :class="{ [`mt-4`]: i !== 0 }"
        >
          <div class="hole-wrap form-row-1 mt-8 mb-8" v-if="i === 0">
            <p class="label pt-0">
              소재타입
              <span class="required">
                <v-icon>mdi-check-circle-outline</v-icon>
                필수
              </span>
            </p>
            <div class="write-con">
              <v-radio-group
                v-model="resourceType"
                @change="changeResourceType"
                class="mt-0"
                row
                hide-details
                height="32px"
              >
                <template v-for="(item, index) in propResourceOptions">
                  <v-radio
                    v-if="item"
                    :key="index"
                    :label="item.name"
                    :value="item.key"
                    color="#fecd00"
                    :class="{ [`radio-type-1`]: true, [`ml-10`]: index === 0 }"
                  ></v-radio>
                </template>
              </v-radio-group>
            </div>
            <div class="btn-resource-add d-flex justify-end">
              <v-btn
                large
                depressed
                max-height="32px"
                color="#fecd06"
                class="button-type-1"
                @click="appendResource"
              >
                <v-icon left> mdi-plus </v-icon>
                {{ label.appendButton[resourceType] }}
              </v-btn>
            </div>
          </div>
          <v-form ref="form">
            <div class="holev-gap">
              <div class="resource-cont relative white rounded pa-6 pb-8 pr-16">
                <!-- resource-box -->
                <div class="resource-box relative">
                  <!-- 소재명 -->
                  <div class="form-row-1">
                    <p class="label">
                      소재명
                      <span class="required">
                        <v-icon>mdi-check-circle-outline</v-icon>
                        필수
                      </span>
                    </p>
                    <div class="write-con">
                      <div class="">
                        <v-text-field
                          v-model="resource.name"
                          label="첨부할 소재명을 입력해주세요. (한글/영문 20자이내)"
                          class="input-custom-2"
                          height="40px"
                          solo
                          :rules="[
                            rules.required,
                            rules.isKrEn,
                            rules.maxLength(20),
                          ]"
                        ></v-text-field>
                      </div>
                    </div>
                  </div>
                  <!-- //소재명 -->
                  <!-- 예약설정 -->
                  <div class="form-row-1 mb-8">
                    <p class="label">
                      예약설정
                      <span class="required">
                        <v-icon>mdi-check-circle-outline</v-icon>
                        필수
                      </span>
                    </p>
                    <div class="write-con">
                      <div class="datepicker-type-1">
                        <v-icon>mdi-calendar-blank</v-icon>
                        <date-range-picker
                          ref="picker"
                          v-model="resource.dateRange"
                          :date-format="dateFormat"
                          :locale-data="localeData"
                          :ranges="false"
                          :time-picker="true"
                          :time-picker-seconds="true"
                          :time-picker-increment="1"
                          opens="right"
                          @update="updateDateRange(resource)"
                        >
                          <template v-slot:input="picker">
                            {{
                              picker.startDate | moment('YYYY.MM.DD HH:mm:ss')
                            }}
                            <span class="ml-3 mr-3"> ~ </span>
                            {{ picker.endDate | moment('YYYY.MM.DD HH:mm:ss') }}
                          </template>
                        </date-range-picker>
                      </div>
                    </div>
                  </div>
                  <!--// 예약설정 -->
                  <!-- 파일업로드 -->
                  <div class="form-row-1 mb-8" style="border: 1p solid blue">
                    <p class="label">
                      파일첨부
                      <span class="required">
                        <v-icon>mdi-check-circle-outline</v-icon>
                        필수
                      </span>
                    </p>
                    <div class="write-con">
                      <div class="d-flex">
                        <div class="file-upload-box-2">
                          <div class="file-thumb">
                            <component
                              :is="resourceType === 'image' ? 'img' : 'video'"
                              v-if="
                                resource.file ||
                                (resource.newFile && resource.newFile.thumb)
                              "
                              :src="getThumbnail(resource)"
                              :controls="resourceType !== 'image'"
                              style="width: 84px; height: 84px"
                            >
                            </component>
                            <v-icon v-else>mdi-image-outline</v-icon>
                          </div>
                          <div class="file-text">
                            <div class="d-flex">
                              <div class="file-wrap">
                                <v-btn
                                  large
                                  depressed
                                  max-height="32px"
                                  color="#fecd06"
                                  class="button-type-1"
                                  type="file"
                                >
                                  파일 업로드
                                </v-btn>
                                <input
                                  type="file"
                                  :accept="`${resourceType}/*`"
                                  @change="fileValidation($event, resource)"
                                />
                              </div>
                              <v-btn
                                v-if="resourceType === 'image'"
                                large
                                depressed
                                max-height="32px"
                                color="#fecd06"
                                class="button-type-1 ml-2"
                                @click.stop="
                                  (showResourceHistory = true),
                                    (modifyResource = resource)
                                "
                              >
                                광고주소재이력
                              </v-btn>
                            </div>
                            <p class="form-coment-1 my-1 mt-3">
                              <v-icon>mdi-alert-circle-outline</v-icon>
                              {{ label.fileComment[resourceType] }}
                            </p>
                            <div
                              v-if="
                                !resource.file ||
                                (resource.newFile && resource.newFile.name)
                              "
                            >
                              <p
                                class="file-name mb-0"
                                v-if="resource.newFile && resource.newFile.name"
                              >
                                {{ resource.newFile.name }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="form-row-1" v-if="resourceType !== 'image'">
                    <p class="label">
                      영상해시
                      <span class="required">
                        <v-icon>mdi-check-circle-outline</v-icon>
                        필수
                      </span>
                    </p>
                    <div class="write-con">
                      <v-text-field
                        v-model="resource.hash"
                        class="input-custom-2"
                        height="40px"
                        :rules="[rules.required]"
                        hide-details
                        solo
                        disabled
                      ></v-text-field>
                    </div>
                  </div>
                  <!-- //파일업로드 -->
                  <!-- 클릭 URL -->
                  <div class="form-row-1 mb-8" v-if="propLinkOption">
                    <p class="label">
                      클릭 URL
                      <span class="required">
                        <v-icon>mdi-check-circle-outline</v-icon>
                        필수
                      </span>
                    </p>
                    <div class="write-con d-flex">
                      <v-select
                        :items="linkTypes"
                        item-text="label"
                        item-value="value"
                        label="선택"
                        v-model="resource.link_type"
                        item-color="#000"
                        class="input-custom-2"
                        height="40px"
                        style="max-width: 16%"
                        solo
                        hide-details
                        :rules="[rules.required]"
                      ></v-select>
                      <v-text-field
                        v-model="resource.link"
                        placeholder="URL 입력 해주세요"
                        :rules="[rules.required]"
                        class="input-custom-2 ml-2"
                        height="40px"
                        style="flex: 1"
                        solo
                      ></v-text-field>
                      <v-btn
                        large
                        depressed
                        max-height="40px"
                        color="#fecd06"
                        class="button-type-1 ml-2"
                        @click.stop="onClickRedirect(resource)"
                        :disabled="
                          !resource.link || resource.link_type === '내부(앱내)'
                        "
                      >
                        미리보기
                      </v-btn>
                    </div>
                  </div>
                  <!-- //클릭 URL -->
                  <!-- 소재삭제버튼 -->
                  <a
                    href="javascript:void(0);"
                    class="btn-ico-delete"
                    @click="openRemoveConfirmPopup(resource, i)"
                  >
                    <v-icon>mdi-delete</v-icon>
                  </a>
                  <!--// 소재삭제버튼 -->
                </div>
                <!-- //resource-box -->
              </div>
            </div>
          </v-form>
        </div>
      </template>
      <ResourceHistory
        v-model="showResourceHistory"
        :propsInventory="propInventory"
        :propsAdvertiserId="propAdvertiserId"
        @historyImgregitst="changeResourceFile"
      />
    </div>
  </v-expand-transition>
</template>

<script>
import bus from '@/utils/bus';
import DateRangePicker from 'vue2-daterange-picker';
import { issueUploadPermissions, uploadToS3 } from '@/api/etc';
import CryptoJS from 'crypto-js';
import _ from 'lodash';
import { validateFileExtension } from '@/utils/validation';
import { deleteResource } from '@/api/campaign';
import ResourceHistory from '~@/modal/ResourceHistoryModal.vue';

export default {
  props: {
    propInventory: Object,
    propLineItem: Object,
    propResourceOptions: Array,
    propHoleOption: Object,
    selectedOptionItem: Object,
    propAdvertiserId: String,
    propLinkOption: Object,
  },
  components: { DateRangePicker, ResourceHistory },
  data: () => ({
    lri: null,
    resources: [],
    resourceType: null,
    rules: {
      required: v => !!v || '필수 항목입니다.',
      maxLength: length => {
        return v =>
          (!!v && v.length <= length) || `최대 ${length}자까지 가능합니다.`;
      },
      isKrEn: v =>
        (!!v && /^[ㄱ-ㅎ|가-힣|a-z|A-Z|0-9|_\-\s]+$/.test(v)) ||
        '한글/영문만 입력 가능합니다.',
    },
    localeData: {
      format: `yyyy-mm-dd HH:MM:ss`,
      applyLabel: '확인',
      cancelLabel: '취소',
      separator: ' ~ ',
    },
    conditions: {},
    logResult: null,
    linkTypes: [],
    showResourceHistory: false,
    modifyResource: null,
    sizeUnitPows: { KB: 1, MB: 2, GB: 3 },
  }),
  computed: {
    condition() {
      return this.conditions[this.resourceType]
        ? this.conditions[this.resourceType]
        : {
            extension: [],
            size: 0,
            sizeUnit: '',
            width: '',
            height: '',
          };
    },
    imageOption() {
      return this.propResourceOptions.find(o => o.key === 'image');
    },
    videoOption() {
      return this.propResourceOptions.find(o => o.key === 'video');
    },
    label() {
      const extensions = this.condition.extension
        .map(e => e.toUpperCase())
        .join(',');
      const sizeComment = `용량 ${
        this.condition.size /
        Math.pow(1024, this.sizeUnitPows[this.condition.sizeUnit])
      }${this.condition.sizeUnit}이하`;
      return {
        appendButton: { image: '이미지 소재추가', video: '동영상 소재추가' },
        fileComment: {
          image: `${extensions} 형식만 사용 가능합니다. (가로 ${this.condition.width}, 세로 ${this.condition.height} / ${sizeComment})`,
          video: `소재 추가시, ${extensions} 타입의 소재만 추가 등록 가능하다. (${sizeComment})`,
        },
      };
    },
  },
  methods: {
    defaultResource() {
      return {
        name: '',
        start_at: this.propInventory.start_at,
        end_at: this.propInventory.end_at,
        is_valid: 'Y',
        type: this.resourceType === 'image' ? 1 : 0,
        hash: '',
        dateRange: this.defaultDateRange(),
        file: null,
        newFile: null,
        link_type: null,
        link: null,
      };
    },
    defaultDateRange() {
      return {
        startDate: this.propInventory.start_at,
        endDate: this.propInventory.end_at,
      };
    },
    defaultFile() {
      return {
        img: null,
        name: null,
        thumb: null,
        path: null,
        type: 1,
      };
    },
    setLri() {
      if (!this.selectedOptionItem) {
        if (this.propHoleOption) return;

        const lri = this.propLineItem.lris.filter(r => r.resources.length)[0];
        const option = lri
          ? this.propResourceOptions.find(o => o.key === lri.client_key)
          : this.propResourceOptions[0];
        return bus.$emit('option_item:select', option.items[0]);
      }

      const itemId = this.selectedOptionItem.id;
      const clientKey = this.selectedOptionItem.client_key;
      this.lri = this.propLineItem.lris.find(lri => lri.item_id === itemId);
      if (!this.lri)
        this.lri = { item_id: itemId, client_key: clientKey, resources: [] };

      if (this.propHoleOption) {
        this.resourceType =
          _.get(this.lri, 'resources[0].type', 1) === 1 ? 'image' : 'video';
      } else {
        this.resourceType = this.lri.client_key;
      }

      this.setResources();
    },
    setResources() {
      if (!this.lri) return;

      const type = this.resourceType === 'image' ? 1 : 0;
      this.resources = this.lri.resources
        .map(r => ({
          ...r,
          dateRange: { startDate: r.start_at, endDate: r.end_at },
          link_type: r.link_type || this.propLineItem.link_type || null,
          link: r.link || this.propLineItem.link_url || null,
        }))
        .filter(r => r.type === type);

      if (this.resources.length === 0) this.appendResource();
    },
    appendResource() {
      this.resources.push(this.defaultResource());
    },
    changeResourceType() {
      if (['image', 'video'].includes(this.selectedOptionItem.client_key)) {
        return bus.$emit(
          'option_item:select',
          this[`${this.resourceType}Option`].items[0],
        );
      }

      this.setResources();
    },
    validate() {
      for (const index in this.$refs.form) {
        const form = this.$refs.form[index];
        const resource = this.resources[index];

        if (!form.validate()) return false;
        if (resource.type !== 0 && resource.type !== 1) return false;
        if (!resource.is_valid) return false;
        if (!resource.start_at || !resource.end_at) return false;
        if (!resource.file && !resource.newFile) return false;
        if (this.propLinkOption) {
          if (!resource.link_type || !resource.link) return false;
        }
      }

      return true;
    },
    async getValues() {
      await Promise.all(
        this.resources.map(async resource => {
          if (this.resourceType === 'image') {
            resource.type = 1;
            resource.hash = null;
          } else {
            resource.type = 0;
          }

          if (resource.newFile) await this.resourceFileUpload(resource);
        }),
      );
      return {
        resources: this.resources.map(r => ({
          ...r,
          link_type: r.link_type || null,
          link: r.link || null,
        })),
      };
    },
    async resourceFileUpload(resource) {
      // 저장 시점에 업로드 키를 발급받아 바로 업로드한다 (실패하면 저장하지 않는다)
      try {
        const category = resource.newFile.img.name.split('.').pop();
        const [permission] = await issueUploadPermissions(category);
        await uploadToS3(permission, resource.newFile.img);
        resource.newFile.permission = permission;
        resource.file = permission.uploadImagePath;
      } catch (error) {
        console.log('error.response', error.response);
        bus.$emit('system_alert:handle', {
          show: true,
          message: '소재 업로드에 실패하였습니다. 다시 시도해주세요.',
        });
        throw error;
      }
    },
    updateDateRange(resource) {
      resource.start_at = resource.dateRange.startDate;
      resource.end_at = resource.dateRange.endDate;
    },
    dateFormat(classes, date) {
      if (!classes.disabled) {
        if (date < this.$moment(this.propInventory.start_at)) {
          classes.disabled = true;
        }
        if (date > this.$moment(this.propInventory.end_at)) {
          classes.disabled = true;
        }
      }
      return classes;
    },
    getThumbnail(resource) {
      return resource.file || resource.newFile.thumb;
    },
    openRemoveConfirmPopup(resource, i) {
      if (resource.id) {
        return bus.$emit('system_alert:handle', {
          show: true,
          message: '정말로 삭제하시겠습니까?',
          continue: async () => await this.removeResource(resource.id),
          abort: () => {},
        });
      }

      this.resources.splice(i, 1);

      if (this.resources.length === 0) this.appendResource();
    },
    async removeResource(resourceId) {
      bus.$emit('start:spinner');
      try {
        const { data } = await deleteResource(
          this.$route.params.id,
          this.propInventory.id,
          this.propLineItem.id,
          this.lri.id,
          resourceId,
        );

        if (data.result === 'success') {
          bus.$emit('system_alert:handle', {
            show: true,
            message: '삭제되었습니다',
            reloadInventory: true,
            reloadLineitem: true,
          });
        }
      } catch (error) {
        console.log(error.response);
      } finally {
        bus.$emit('end:spinner');
      }
    },
    fileValidation(event, resource) {
      const targetFile = event.target.files[0];
      if (!targetFile) return;

      if (!validateFileExtension(targetFile, this.condition.extension)) {
        return bus.$emit('system_alert:handle', {
          show: true,
          message: `${this.condition.extension
            .map(e => e.toUpperCase())
            .join(',')} 형식만 사용 가능 합니다.`,
        });
      }
      if (targetFile.size > this.condition.size) {
        return bus.$emit('system_alert:handle', {
          show: true,
          message: '가이드에 맞지 않는 용량 입니다.',
        });
      }

      // 해상도가 맞지 않으면 되돌릴 수 있게 이전 파일을 기억한다
      const previous = { file: resource.file, newFile: resource.newFile };
      resource.file = null;
      resource.newFile = {
        name: targetFile.name,
        thumb: URL.createObjectURL(targetFile),
        img: targetFile,
        type: 1,
      };
      event.target.value = '';

      this[`${this.resourceType}Validation`](resource, previous);
    },
    imageValidation(resource, previous) {
      const img = new Image();
      img.src = resource.newFile.thumb;
      img.onload = () => {
        if (
          img.width !== parseInt(this.condition.width) ||
          img.height !== parseInt(this.condition.height)
        ) {
          resource.file = previous.file;
          resource.newFile = previous.newFile;
          return bus.$emit('system_alert:handle', {
            show: true,
            message: '가이드에 맞지 않는 해상도 입니다.',
          });
        }
      };
    },
    videoValidation(resource) {
      const reader = new FileReader();
      reader.onload = event => {
        const binary = event.target.result;
        const wordArray = CryptoJS.lib.WordArray.create(binary);
        resource.hash = CryptoJS.MD5(wordArray).toString();
      };

      reader.readAsArrayBuffer(resource.newFile.img);
    },
    onClickRedirect(resource) {
      const url = resource.link.replace(/\s/g, '');
      const lowerUrl = `${url}`.toLowerCase();
      if (!lowerUrl.startsWith('http://') && !lowerUrl.startsWith('https://')) {
        window.open(`https://${url}`, '_blank');
      } else {
        window.open(url, '_blank');
      }
    },
    changeResourceFile(data) {
      this.modifyResource.newFile = null;
      this.modifyResource.file = data.file;
      this.modifyResource = null;
    },
  },
  watch: {
    propLineItem: {
      deep: true,
      handler() {
        this.setLri();
      },
    },
    selectedOptionItem: {
      deep: true,
      handler() {
        this.setLri();
      },
    },
  },
  created() {
    this.propResourceOptions.forEach(o => {
      if (!this.resourceType) this.resourceType = o.key;
      this.conditions[o.key] = o.condition;
    });

    if (this.propLinkOption) {
      this.linkTypes = this.propLinkOption.items.map(i => ({
        label: i.name,
        value: i.client_key,
      }));
    }

    this.setLri();
  },
};
</script>

<style lang="scss" scoped>
.hole-wrap {
  margin-top: 0px !important;
  padding-left: 0px !important;
  height: 32px !important;
  line-height: 32px !important;
}
.holev-gap {
  .resource-cont {
    padding-left: 0px !important;
    padding-right: 0px !important;
    padding-top: 0px !important;
  }
  .btn-resource-add {
    position: absolute;
    top: 24px;
    right: 64px;
  }
}
.file-name {
  display: none;
}
</style>
